import { render, staticRenderFns } from "./ScopeOption.vue?vue&type=template&id=1962f1ba&scoped=true"
import script from "./ScopeOption.vue?vue&type=script&lang=js"
export * from "./ScopeOption.vue?vue&type=script&lang=js"
import style0 from "./ScopeOption.vue?vue&type=style&index=0&id=1962f1ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1962f1ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1962f1ba')) {
      api.createRecord('1962f1ba', component.options)
    } else {
      api.reload('1962f1ba', component.options)
    }
    module.hot.accept("./ScopeOption.vue?vue&type=template&id=1962f1ba&scoped=true", function () {
      api.rerender('1962f1ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/ScopeOption.vue"
export default component.exports